import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { CartDto } from "@aurelia/types";
import { apiFetch } from "../../lib/api-client";
import { toast } from "@aurelia/ui";

function useCartMutation<T>(fn: (arg: T) => Promise<CartDto>) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: (cart) => queryClient.setQueryData(["cart"], cart)
  });
}

export function useAddToCart() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (payload: { variantId: string; quantity?: number }) =>
      apiFetch<CartDto>("/cart/items", { method: "POST", body: JSON.stringify(payload) }),
    onSuccess: (cart) => {
      queryClient.setQueryData(["cart"], cart);
      toast("Added to cart", "success");
    }
  });
}

export function useUpdateCartItem() {
  return useCartMutation((payload: { itemId: string; quantity: number }) =>
    apiFetch<CartDto>(`/cart/items/${payload.itemId}`, {
      method: "PATCH",
      body: JSON.stringify({ quantity: payload.quantity })
    })
  );
}

export function useRemoveCartItem() {
  return useCartMutation((itemId: string) =>
    apiFetch<CartDto>(`/cart/items/${itemId}`, { method: "DELETE" })
  );
}

export function useAddBundleToCart() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (bundleId: string) => apiFetch<CartDto>(`/cart/bundles/${bundleId}`, { method: "POST" }),
    onSuccess: (cart) => {
      queryClient.setQueryData(["cart"], cart);
      toast("Added to cart", "success");
    }
  });
}

export function useRemoveBundleFromCart() {
  return useCartMutation((bundleId: string) =>
    apiFetch<CartDto>(`/cart/bundles/${bundleId}`, { method: "DELETE" })
  );
}
